import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { BookingSummarySection } from './BookingSummarySection';
import { INewBooking } from '../../../../domain/booking/models/INewBooking';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { BookingSummaryChangeButton } from './BookingSummaryChangeButton';
import { BookingSummarySavings } from './BookingSummarySavings';
import { BookingDate } from '../../../booking/BookingDate';

interface IFormattedDateTime {
	label: string;
	date: Date;
	preservedTime?: string;
}

const FormattedDateTime = ({
	label,
	date,
	preservedTime,
}: IFormattedDateTime) => (
	<div>
		{label}: <BookingDate date={date} selectedTime={preservedTime} />
	</div>
);

interface IParkingProductSummary {
	booking: INewBooking;
	changeButtonUrl?: string;
	children?: ReactNode | ReactNode[];
}

export const ParkingProductSummary = observer(
	({ booking, changeButtonUrl, children }: IParkingProductSummary) => {
		const { t } = useTranslation();

		if (!booking.parkingProduct) {
			return null;
		}

		return (
			<BookingSummarySection
				title={booking.parkingProduct.name}
				daysInTotal={booking.daysInTotal}
				price={booking.parkingProduct.price.originalValue}
			>
				{booking.entryDate && (
					<FormattedDateTime
						label={t('parking_booking_entry_date')}
						date={booking.entryDate}
						preservedTime={booking.entryTime}
					/>
				)}
				{booking.exitDate && (
					<FormattedDateTime
						label={t('parking_booking_exit_date')}
						date={booking.exitDate}
						preservedTime={booking.exitTime}
					/>
				)}

				{changeButtonUrl && (
					<BookingSummaryChangeButton url={changeButtonUrl} />
				)}

				<BookingSummarySavings booking={booking} />
				{children}
			</BookingSummarySection>
		);
	},
);
